<template lang="pug">
  div.main
    div.mainInr
      Header
      SideMenu
      div.contents(:data-id="number")
        Front(v-if="view === 1")
        Side(v-if="view === 2") 側面
        Top(v-if="view === 3") 上面
        ItemInfo
      Status
    div.loading(v-if="loading") Loading ...
</template>

<script>
import store from '../stores/index';
import Header from './header/Header.vue';
import SideMenu from './sidemenu/SideMenu.vue';
import Status from './status/Status.vue';
import Front from './front/Front.vue';
import Side from './side/Side.vue';
import Top from './top/Top.vue';
import axios from 'axios';
import ItemInfo from './parts/ItemInfo.vue';
export default{
  name: 'Set',
  components: {
    Header,
    SideMenu,
    Front,
    Side,
    Top,
    ItemInfo,
    Status
  },
  data () {
    return {
      timer: {},
      loading: true,
      flg: false
    };
  },
  computed: {
    color () {
      return this.$store.state.color;
    }
  },
  watch: {
    id (i, s) {
      this.flg = false;
    },
    color () {
      this.loadParts();
    }
  },
  methods: {
    loadSpan () {
      let me = this;
      axios.get('./static/json/span.json').then(function (response) {
        store.commit('setSpanitems', response.data);
      });
      if (Number(me.$route.params.id) !== 1) {
        me.$router.push({path: '/' + (me.sets.length + 1)});
      }
      window.onpopstate = function () {
        me.flg = true;
        let id = me.$route.params.id || 1;
        store.commit('setId', id);
      };
      me.loading = false;
    },
    loadRail () {
      let me = this;
      let url = '';
      if (this.config.type === 'c') {
        url = '/api/rails';
      } else {
        this.axiosConfig.headers.Authorization = 'Bearer ' + localStorage.token;
        url = '/api/btob-rails';
      }
      axios.get(this.config.baseURL + url, this.axiosConfig).then(function (response) {
        let railitems = response.data[0];
        store.commit('setRailitems', railitems);
        me.loadSpan();
      });
    },
    loadSlit () {
      let me = this;
      if (this.sets.length === 0) {
        let url = '';
        if (this.config.type === 'c') {
          url = '/api/slits';
        } else {
          this.axiosConfig.headers.Authorization = 'Bearer ' + localStorage.token;
          url = '/api/btob-slits';
        }
        axios.get(this.config.baseURL + url, this.axiosConfig).then(function (response) {
          let slititems = response.data[0];
          store.commit('setSlititems', slititems);
          me.loadRail();
        });
      } else {
        me.loadSpan();
      }
    },
    loadItem (parts, category, railsspan) {
      let me = this;
      let ary = [];
      let aryitem = [];
      let url = '';
      let col = this.$store.state.color;
      if (this.config.type === 'c') {
        url = '/api/products?color_ct=' + col + ',2';
      } else {
        this.axiosConfig.headers.Authorization = 'Bearer ' + localStorage.token;
        url = '/api/btob-products';
      }
      axios.get(this.config.baseURL + url, this.axiosConfig).then(function (response) {
        me.parts = parts;
        // me.category = category;
        me.items = response.data[0];
        for (let prop in me.items) {
          let id = me.items[prop].code;
          ary[id] = me.acopy(me.items[prop]);
        }
        for (let prop in me.parts) {
          let iary = [];
          let wary = [];
          let pary = [];
          for (let prop2 in me.parts[prop].item) {
            if (ary[me.parts[prop].item[prop2]] !== undefined) {
              let itm = me.acopy(ary[me.parts[prop].item[prop2]]);
              if (Number(prop2) === 0) {
                me.parts[prop].thumb = itm;
              }
              wary.push(itm.w * 10);
              pary.push(me.addComma(itm.price));
              iary.push(ary[me.parts[prop].item[prop2]]);
            }
          }
          if (me.parts[prop].thumb !== undefined) {
            me.parts[prop].display = true;
            me.parts[prop].thumb.w = wary.join('、');
            me.parts[prop].thumb.price = pary.join('、');
            me.parts[prop].item = iary;
            aryitem.push(me.parts[prop]);
          }
        }
        me.parts2 = me.acopy(aryitem);
        store.commit('setPartsitems', aryitem);
        store.commit('setCategory', category);
        store.commit('setRailsspan', railsspan);
        me.loadSlit();
      });
    },
    loadParts () {
      let me = this;
      let url = '';
      if (this.config.type === 'c') {
        url = '/api/btoc/json-data';
      } else {
        this.axiosConfig.headers.Authorization = 'Bearer ' + localStorage.token;
        url = '/api/btob/json-data';
      }
      axios.get(this.config.baseURL + url, this.axiosConfig).then(function (response) {
        me.loadItem(response.data.parts, response.data.category, response.data.rails);
      });
      // axios.get('./static/json/parts.json').then(function (response) {
      //   me.loadItem(response.data.parts, response.data.category, response.data.rails);
      // });
      if (this.config.type === 'b') {
        let url = '/api/user';
        this.axiosConfig.headers.Authorization = 'Bearer ' + localStorage.token;
        axios.get(this.config.baseURL + url, this.axiosConfig).then(function (response) {
          let user = response.data;
          store.commit('setLoginUser', user);
        });
      }
    }
  },
  created () {
    let me = this;
    if (this.sets.length === 0) {
      axios.get('./static/config.json').then(function (response) {
        store.commit('setConfig', response.data);
        clearTimeout(me.timer);
        me.timer = setTimeout(function () {
          me.loadParts();
        }, 500);
      });
    } else {
      me.loadSpan();
    }
  },
  mounted () {
    store.commit('setPreview', false);
  }

};
</script>

<style lang="stylus" scoped>
  .main
    position absolute
    left 0
    top 0
    width 100%
    height 100%
  .contents
    position absolute
    left 160px
    right 0
    top 50px
    bottom 0
    background #efefef
    overflow auto
  h1, h2
    font-weight normal
  ul
    list-style-type: none
    padding 0
  li
    display inline-block
    margin 0 10px
  a
    color #42b983

  .loading
    display flex
    justify-content center
    align-items center
    background-color #ffffff
    position absolute
    z-index 10
    left 0
    right 0
    top 0
    bottom 0

</style>



// WEBPACK FOOTER //
// src/components/Set.vue